/**
 * ============================================================================
 * СЕРВИС ОТЗЫВОВ О КУРСАХ
 * ============================================================================
 */

import api from './api'

export const courseReviewsService = {
	async getByCourseId(courseId) {
		const response = await api.get(`/courses/${courseId}/reviews`)
		return response?.data ?? response
	},

	async upsert(courseId, payload) {
		const response = await api.post(`/courses/${courseId}/reviews`, payload)
		return response?.data ?? response
	},

	async toggleLike(courseId, reviewId) {
		const response = await api.post(
			`/courses/${courseId}/reviews/${reviewId}/like`,
		)
		return response?.data ?? response
	},
}

export default courseReviewsService
